<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm" v-can:update="permissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <files-image v-model="image" :options="{ id: 'image', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <input-text v-model="en_name" :options="{ id: 'en_name', label: 'en_name', disabled: true }"/>
              <input-text v-model="ar_name" :options="{ id: 'ar_name', label: 'ar_name', disabled: true }"/>
              <input-text v-model="jwt_callback_token" :options="{ id: 'jwt_callback_token', transPrefix: `${transPrefix}.fields`, label: 'jwt_callback_token', disabled: true }"/>
              <input-text v-model="web_hook_url" :options="{ id: 'web_hook_url', transPrefix: `${transPrefix}.fields`, label: 'web_hook_url', disabled: true }"/>
              <input-text v-model="order_prefix_url" :options="{ id: 'order_prefix_url', transPrefix: `${transPrefix}.fields`, label: 'order_prefix_url', disabled: true }"/>
              <select-countries v-model="country_id" :options="{ id: 'country_id', label: 'country', disabled: true }"/>
              <input-text v-model="client_id" :options="{ id: 'client_id', transPrefix: `${transPrefix}.fields`, label: 'client_id', disabled: true }"/>
              <input-text v-model="client_secret" :options="{ id: 'client_secret', transPrefix: `${transPrefix}.fields`, label: 'client_secret', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <input-checkbox v-model="enabled" :options="{ id: 'enabled', label: 'enabled', disabled: true }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { PLATFORMS_SHOW as CRUD_ACTION_SHOW } from 'actions/platforms';
  const CRUD_CODE="platforms";
  export default {
    name: "PlatformShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_CODE,
        id:this.$router.currentRoute.params.id,
        ar_name: '',
        en_name: '',
        jwt_callback_token: '',
        web_hook_url: '',
        order_prefix_url: '',
        country_id: "",
        enabled: false,
        client_id: '',
        client_secret: '',
        image:{
          file:'',
          thumbnail:'',
        },
        serverError: '',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.en_name=response.data.name;
          this.ar_name=response.data.nameAr;
          this.client_id=response.data.clientId;
          this.client_secret=response.data.clientSecret;
          this.jwt_callback_token=response.data.jwtCallbackToken;
          this.web_hook_url=response.data.webHookUrl;
          this.order_prefix_url=response.data.orderPrefixUrl;
          this.country_id=response.data.country?response.data.country.id:null;
          this.enabled=response.data.enabled;
          this.image.thumbnail=response.data.image?response.data.image.url:'';
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
